import RelatedPosts from "./RelatedPosts"
import "./relatedPosts.scss"

export default RelatedPosts
